import React from 'react';
import {
  CallAgentModalContainer,
  CallAgentModalImage,
  CallAgentModalOption,
  CallAgentModalTitle,
  ContactNumber,
  ContactText,
  CallAgentContactDetails,
} from './CallAgentModal.style';
import WhiteModal from './WhiteModal';

export interface AgentNumber {
  label: string;
  id: string;
  logo?: string;
}

interface CallAgentModalProps {
  onClose: () => void;
  show: boolean;
  items: AgentNumber[];
  onSelected: (a: AgentNumber) => void;
  developer?: boolean;
}

const CallAgentModal: React.FC<CallAgentModalProps> = ({ onClose, show, items, onSelected, developer }) => {
  return (
    <WhiteModal ariaLabel="Call an agent" show={show} onClose={onClose} maxWidth={670}>
      <CallAgentModalContainer>
        <CallAgentModalTitle data-testid="agent-contact-title">
          Call The {developer ? 'Developer' : 'Agent'}
        </CallAgentModalTitle>
        {items &&
          items.map((item) => (
            <CallAgentModalOption key={item.id} data-testid="agent-contact-item">
              {item.logo && (
                <CallAgentModalImage src={item.logo} alt={`${item.label} Logo`} data-testid="agent-contact-logo" />
              )}
              <CallAgentContactDetails>
                <ContactText data-testid="agent-contact-text">Call {item.label}</ContactText>
                <ContactNumber
                  data-testid="agent-contact-number"
                  href={`tel:${item.id.replace(/\s/g, '')}`}
                  onClick={() => onSelected(item)}
                >
                  {item.id}
                </ContactNumber>
              </CallAgentContactDetails>
            </CallAgentModalOption>
          ))}
      </CallAgentModalContainer>
    </WhiteModal>
  );
};

export default CallAgentModal;
